module.exports = __webpack_public_path__ + "img/horizontal_6_5_6000.2888adc7.png";